import React from 'react';
import '../assets/styles/components.css';
import Carousel from './Carousel';
import ClientCarousel from './ClientCarousel';
import { Helmet } from 'react-helmet';

const Team = () => {

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Blockweb Africa",
    "url": "https://blockwebafrica.com/",
    "logo": "https://blockwebafrica.com/public/BlockWebLogo.png",
    "member": [
      {
        "@type": "Person",
        "name": "Micheal Nyamute",
        "jobTitle": "Technical Consultant",
        "worksFor": "Blockweb Africa"
      },
      {
        "@type": "Person",
        "name": "Robert Mathu",
        "jobTitle": "Principal Consultant",
        "worksFor": "Blockweb Africa"
      },
      {
        "@type": "Person",
        "name": "Tom Waruinge",
        "jobTitle": "Technical Consultant",
        "worksFor": "Blockweb Africa"
      }
    ],
    "description": "The consulting team at Blockweb Africa comprises experienced professionals specializing in capital markets, financial technology, and regulatory frameworks across Africa."
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div className="services-section">
          {/* Title */}
          <div className='title-section' id="team">
              <h1 className='services-title font-bold' style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center' }}>Meet the Team</h1>
          </div>
          {/* Team Carousel */}
          <div>
            <Carousel />
          </div>
          {/* Client Portfolio */}
          <div className='title-section' id="about us">
              <h1 className='services-title font-bold' style={{ marginTop: '5px', marginBottom: '10px', textAlign: 'center' }}>Client Portfolio</h1>
          </div>
          {/* Client Carousel */}
          <div>
            <ClientCarousel />
          </div>
      </div>
    </>
  );
};

export default Team;